import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'

import { CustomModal, InputPhone } from '../../../../components'

const INITIAL_STATE = {
  fleet_id: 0,
  sent_time: '',
  expected_date: '',
  vehicle_badge: '',
  vehicle_driver: '',
  driver_phone: '',
  qte_deliveries: 0,
  qte_faltas: 0,
}

function ModalTelefone({ onModalClose, data, show }) {
  const [state, setState] = useState({ ...INITIAL_STATE })

  useEffect(() => {
    if (data) {
      setState(prevState => {
        return { ...prevState, ...data }
      })
    }
  }, [data])

  return (
    <CustomModal header="Detalhes" isVisible={show} onClose={onModalClose} width={600}>
      <InputPhone
        label="Telefone do Motorista"
        marginTop={10}
        value={state.driver_phone}
        disabled
      />
    </CustomModal>
  )
}

export default connect()(ModalTelefone)
